/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One audience question in a live Q&A feed.
 */
export type QAItem = {
    id?: string;
    body?: string;
    status?: QAItem.status;
    upvotes?: number;
    /**
     * Whether the requesting voter upvoted this item.
     */
    mine?: boolean;
    createdAt?: string;
};
export namespace QAItem {
    export enum status {
        OPEN = 'open',
        ANSWERED = 'answered',
        HIDDEN = 'hidden',
    }
}

